import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import AnyLink from '../common/anyLink';
import imgParams from '../../utils/imageUtil';
import analytics from '../../services/analyticsService';
import { eventProps, eventNames } from '../../utils/eventConstants';
import { useDimensions } from '../../hooks/utilHooks';

const Promocard = ({ post }) => {
  const classes = useStyles();
  const { width, ref } = useDimensions();

  function promocardClicked() {
    analytics.track(eventNames.imageCardCliked, {
      [eventProps.url]: post.deepLinkUrl,
      [eventProps.id]: post.entityId,
    });
  }
  return (
    <React.Fragment>
      {post && post.imageUrl && (
        <Box onClick={promocardClicked} width={1}>
          <AnyLink to={post.deepLinkUrl}>
            <Box>
              <img
                ref={ref}
                className={classes.img}
                height={'250px'}
                src={imgParams(post.imageUrl, width * 2)}
                alt="promocard"
              />
            </Box>
          </AnyLink>
        </Box>
      )}
      <Box mb={2} />
    </React.Fragment>
  );
};

const useStyles = makeStyles((theme) => ({
  img: {
    display: 'block',
    width: '100%',
    margin: '0px auto',
  },
}));

export default Promocard;
